var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52717 21C4.11246 21 3.75426 20.8491 3.45257 20.5474C3.15086 20.2457 3 19.8875 3 19.4728V4.52717C3 4.11246 3.15086 3.75427 3.45257 3.45257C3.75426 3.15086 4.11246 3 4.52717 3H19.4728C19.8875 3 20.2457 3.15086 20.5474 3.45257C20.8491 3.75427 21 4.11246 21 4.52717V19.4728C21 19.8875 20.8491 20.2457 20.5474 20.5474C20.2457 20.8491 19.8875 21 19.4728 21H4.52717ZM4.52717 19.7987H19.4728C19.5679 19.7987 19.6459 19.7681 19.707 19.707C19.7681 19.6459 19.7987 19.5679 19.7987 19.4728V6.319H4.20134V19.4728C4.20134 19.5679 4.23189 19.6459 4.29299 19.707C4.35408 19.7681 4.43214 19.7987 4.52717 19.7987Z",
    fill: "#343333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5717 12.5C13.5717 13.3284 12.8679 14 11.9998 14C11.1316 14 10.4278 13.3284 10.4278 12.5C10.4278 11.6716 11.1316 11 11.9998 11C12.8679 11 13.5717 11.6716 13.5717 12.5Z",
    stroke: "#343333",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5C7.6677 10.4714 9.65377 9 12 9C14.3462 9 16.3323 10.4715 17 12.5C16.3323 14.5286 14.3462 16 12 16C9.65377 16 7.66769 14.5285 7 12.5Z",
    stroke: "#343333",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.0746206f82b49183485d28effe503924.svg";
export { ForwardRef as ReactComponent };